/**
 * THE DRESS OF EVERY PAGE A CLIENT OPENS WITHOUT SIGNING IN: the business's name and mark on navy
 * above one narrow column on cream, and no shell and no navigation. Her invoice or visit report
 * (`PublicPage.tsx`) and the page Stripe sends her back to (`PaymentReturn.tsx`) both wear it, so the
 * page she comes back to looks like the page she left.
 */
import type { ReactNode } from 'react';

export function PublicFrame({
  household,
  children,
}: {
  /** The household the page is for, when the page knows it. */
  household?: string | null;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh bg-cream text-navy">
      <header className="bg-navy text-cream">
        <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 py-4">
          <img
            src="/logo-mark-reverse.svg"
            alt=""
            width={320}
            height={166}
            className="h-8 w-auto"
          />
          <div>
            <p className="font-serif text-xl leading-tight">Faithfully Kept</p>
            {household ? <p className="mt-1 text-sm text-cream/80">For {household}</p> : null}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-6">{children}</main>
    </div>
  );
}
